"use client";
import { TaxiFormProps } from "@/components/TaxiForm/types";
import TaxiForm from "../../TaxiFormMain";

export default function DefaultTaxiForm(props: TaxiFormProps) {
  return <TaxiForm {...props} />;
}
